import { getParameterByName } from '@fable/utils'
import { routes } from '../routes'

export const platformParam = getParameterByName('platform')
export const isAndroid = !!platformParam && platformParam === 'android'

export const appendModeCors = (imageUrl: string): string => {
  return imageUrl.includes('?')
    ? `${imageUrl}&mode=cors`
    : `${imageUrl}?mode=cors`
}

export const isWebViewRoute = (pathname: string) => {
  const wvRoutes = Object.values(routes).map((r) => r)
  const isStats = pathname.includes(routes.stats)
  return isStats || wvRoutes.includes(pathname)
}

/**
 * Parses a version string and returns a comparable number
 * @param versionString - Version string like "0.236.20471" or "236"
 * @returns The major version number as an integer
 */
const parseVersionNumber = (versionString: string): number => {
  if (!versionString) return 0

  // Handle iOS format: "236" -> 236
  if (/^\d+$/.test(versionString)) {
    return parseInt(versionString, 10)
  }

  // Handle Android format: "0.236.20471" -> 236
  const parts = versionString.split('.')
  if (parts.length >= 2) {
    return parseInt(parts[1], 10)
  }

  return 0
}

/**
 * Gets the current app version from URL parameters
 * @returns The current app version number
 */
const getCurrentAppVersion = (): number => {
  if (isAndroid) {
    const appVersionParam = getParameterByName('appVersion')
    return parseVersionNumber(appVersionParam || '')
  } else {
    // iOS - get from flags parameter
    const flagsParam = getParameterByName('flags')
    if (!flagsParam) return 0

    try {
      const flags = JSON.parse(decodeURIComponent(flagsParam))
      return parseVersionNumber(flags.app_version?.toString() || '')
    } catch {
      return 0
    }
  }
}

/**
 * Checks if the current app version meets or exceeds the required version
 * @param requiredVersion - The minimum version number required
 * @returns True if current version >= required version
 */
export const isAppVersionAtLeast = (requiredVersion: number): boolean => {
  const currentVersion = getCurrentAppVersion()
  return currentVersion >= requiredVersion
}
